export default function isBase64SrcImageUtil (src) {
  if (!src) {
    return false
  }
  return src.startsWith('data:image')
}
